module.exports = __webpack_public_path__ + "static/img/pc_pd_v2_4.93bb2d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pc_pd_v2_4.png
// module id = cJAJ
// module chunks = 0